module.exports = __webpack_public_path__ + "img/Clio.0504aa9d.jpg";